import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class MergePurchaseOrderZendeskTicketArgs extends ActionArgs {
  @Field(() => String)
  purchaseOrderId: string

  @Field(() => String)
  sourceTicketId: string

  @Field(() => String)
  targetTicketId: string
}
